import React from 'react';
import { useTranslation } from 'react-i18next';

const AboutUs = () => {
    const { t, i18n } = useTranslation();

    return (
        <div dir={t('dir')} className="min-h-center flex flex-col">
            <main className="flex-grow">
                <header className="max-w-5xl mx-auto text-center py-10 px-4 sm:px-0">
                    {/* <h1 className="text-4xl sm:text-5xl font-extrabold text-blue-700 mb-4 leading-tight">{t('aboutUs')}</h1> */}
                     <h1 className="text-3xl font-bold text-center mb-8 text-blue-600">
                        {t('aboutUs')}
                    </h1>
                </header>
                <div className="max-w-5xl mx-auto bg-white shadow-lg rounded-lg overflow-hidden flex flex-col md:flex-row">
                    {/* صورة جانبية */}
                    <div className="md:w-1/2">
                        <img src="/logo.png" alt="Abdo Transport" className="w-200 h-200 object-cover" />
                    </div>

                    {/* نص تعريف الشركة */}
                    <div className="md:w-1/2 p-12">
                        <h2 className="text-3xl font-bold text-blue-700 mb-4">
                            {t("appName")}
                        </h2>
                        <p className="text-gray-700 text-lg leading-relaxed">
                            {t('aboutUsText')}
                        </p>
                        <p className="text-gray-700 mt-4 text-lg leading-relaxed">
                            {t('aboutUsText2')}
                        </p>
                    </div>
                </div>
            </main>
        </div >
    );
};

export default AboutUs;
